import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
export const CustomizationContext = createContext({
    quantity: 1,
    setQuantity: () => { },
    meals: [],
    setMeals: () => { },
    days: [],
    setDays: () => { },
    day: undefined,
    setDay: () => { },
    isAddDisabled: false,
    setIsAddDisabled: () => { },
    resetContext: () => { },
    assignmentId: undefined,
    setAssignmentId: () => { },
});
export const CustomizationContextProvider = ({ children }) => {
    const [quantity, setQuantity] = useState(1);
    const [meals, setMeals] = useState([]);
    const [days, setDays] = useState([]);
    const [day, setDay] = useState(undefined);
    const [isAddDisabled, setIsAddDisabled] = useState(false);
    const [assignmentId, setAssignmentId] = useState(undefined);
    const resetContext = () => {
        setQuantity(1);
        setMeals([]);
        setDays([]);
        setDay(undefined);
        setIsAddDisabled(false);
        setAssignmentId(undefined);
    };
    return (_jsx(CustomizationContext.Provider, Object.assign({ value: {
            quantity,
            setQuantity,
            meals,
            setMeals,
            days,
            setDays,
            day,
            setDay,
            isAddDisabled,
            setIsAddDisabled,
            resetContext,
            assignmentId,
            setAssignmentId,
        } }, { children: children })));
};
export const CustomizationModalStateContext = createContext({
    isCustomizeModalOpen: false,
    setIsCustomizeModalOpen: () => { },
});
export const CustomizationModalStateContextProvider = ({ children }) => {
    const [isCustomizeModalOpen, setIsCustomizeModalOpen] = useState(false);
    return (_jsx(CustomizationModalStateContext.Provider, Object.assign({ value: { isCustomizeModalOpen, setIsCustomizeModalOpen } }, { children: children })));
};
